import ouiBase from '@goldwasserexchange/oui';
import { useAccountHistoryFieldApiByHisMvtId } from '../api';

export const useAccountHistoryHisMvtOperDate = () => {
  const hisMvtId = ouiBase.utils.dimensions.useCurrentPrimaryDimension();
  const result = useAccountHistoryFieldApiByHisMvtId({
    hisMvtId,
    field: 'HIS_MVT.OPER_DATE',
  });
  return result;
};
